import React, { useState, useEffect } from "react";
import BotonManualHeader from "../../components/BotonManualHeader";
import {
  Container,
  Card,
  Table,
  Badge,
  Button,
  Modal,
  Form,
  Row,
  Col,
  Alert,
  Spinner,
  ButtonGroup,
  OverlayTrigger,
  Tooltip,
  Dropdown,
  ProgressBar,
} from "react-bootstrap";
import {
  collection,
  query,
  where,
  getDocs,
  getDoc,
  doc,
  updateDoc,
  addDoc,
  setDoc,
  orderBy,
  limit,
  getFirestore,
  writeBatch,
  collectionGroup,
  startAfter,
  serverTimestamp,
} from "firebase/firestore";
import { getFunctions, httpsCallable } from "firebase/functions";
import {
  FaCheck,
  FaTimes,
  FaEye,
  FaClock,
  FaFilter,
  FaUserCheck,
  FaExclamationTriangle,
  FaCalendarAlt,
  FaMapMarkerAlt,
  FaClipboardList,
  FaCheckSquare,
  FaSquare,
} from "react-icons/fa";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import Swal from "sweetalert2";
import firebaseApp from "../../firebase/credenciales";
import { notificarAprobacion, notificarRechazo } from "../../services/notificacionesService";
import {
  requestApprovalWithReasonModal,
  showApprovalRequestCreatedAlert,
} from "../../functions/approvalFlowAlerts";
import {
  cargarAlcanceGrupoAsistencia,
  filtrarPorDnisPermitidos,
} from "./groupScope";
import { checkPermission } from "../../functions/checkPermission";

const db = getFirestore(firebaseApp);
const functions = getFunctions(firebaseApp, "us-central1");
const ATTENDANCE_APPROVAL_PROCESS = "attendance_approval";
const toTitleCase = (value = "") =>
  String(value || "")
    .trim()
    .split("_")
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");

const parseFecha = (val) => {
  if (!val) return null;
  if (typeof val.toDate === "function") {
    try {
      return val.toDate();
    } catch (e) {
      /* fallback */
    }
  }
  if (val instanceof Date) return val;
  if (typeof val === "number") return new Date(val);
  if (typeof val === "string") {
    const d = new Date(val);
    return isNaN(d.getTime()) ? null : d;
  }
  if (typeof val === "object" && typeof val.seconds === "number") {
    return new Date(val.seconds * 1000 + (val.nanoseconds || 0) / 1000000);
  }
  return null;
};

const AprobacionesAsistencia = ({ usuario }) => {
  const [solicitudes, setSolicitudes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [primeraVez, setPrimeraVez] = useState(true);

  const [filtros, setFiltros] = useState({
    estado: "Pendiente",
    tipo: "",
    fechaDesde: "",
    fechaHasta: "",
    empleado: "",
    grupo: "",
  });
  const [showModal, setShowModal] = useState(false);
  const [solicitudSeleccionada, setSolicitudSeleccionada] = useState(null);
  const [motivoRechazo, setMotivoRechazo] = useState("");
  const [procesando, setProcesando] = useState(false);
  const [empleados, setEmpleados] = useState([]);
  const [totalRegistros, setTotalRegistros] = useState(0);

  // **NUEVO**: Estados para selección múltiple
  const [seleccionados, setSeleccionados] = useState(new Set());
  const [seleccionarTodos, setSeleccionarTodos] = useState(false);

  // **MEJORA 1**: Estados para paginación
  const [lastVisible, setLastVisible] = useState(null);
  const [cargandoMas, setCargandoMas] = useState(false);
  const [hayMasResultados, setHayMasResultados] = useState(true);

  // **MEJORA 2**: Estado para buscador inteligente
  const [textoBusquedaEmpleado, setTextoBusquedaEmpleado] = useState("");

  // **MEJORA 3**: Estados para barra de progreso
  const [mostrarProgreso, setMostrarProgreso] = useState(false);
  const [progresoActual, setProgresoActual] = useState(0);
  const [mensajeProgreso, setMensajeProgreso] = useState("");
  const [scopeLoading, setScopeLoading] = useState(true);
  const [dnisPermitidos, setDnisPermitidos] = useState(null);
  const [gruposScope, setGruposScope] = useState([]);
  const [approvalRequests, setApprovalRequests] = useState(new Map());
  const [policyLevels, setPolicyLevels] = useState([
    { level: 1, roles: ["rh"], minApprovers: 1 },
    { level: 2, roles: ["admin"], minApprovers: 1 },
  ]);
  const [policyBypassRoles, setPolicyBypassRoles] = useState([]);
  const rucEmpresa = String(usuario?.ruc || usuario?.rucEmpresa || usuario?.empresa?.ruc || usuario?.empresaRuc || usuario?.rucEmpresaActiva || "").trim();
  const rolActual = String(usuario?.rol || "").toLowerCase();
  const esSuperAdmin = rolActual === "superadmin";
  const isSingleLevelFlow = policyLevels.length === 1;
  const [soloMiBandeja, setSoloMiBandeja] = useState(false);
  const approvalLevelsForModal = policyLevels.map((lvl) => ({
    role: (lvl.roles || []).map((r) => toTitleCase(r)).join(" / ") || "Rol",
    level: `L${lvl.level}`,
  }));
  const firstLevelRoles = (policyLevels.find((lvl) => lvl.level === 1)?.roles || []).map((r) => String(r).toLowerCase());
  const matchesRoleOrPermission = (targetRoles = []) => {
    if (esSuperAdmin || rolActual === "admin" || rolActual === "administrador") return true;
    if (checkPermission(usuario, "asistencia") || checkPermission(usuario, "asistencia", "APROBAR")) return true;
    const normUserRole = String(rolActual || "").toLowerCase().trim();
    const rhSynonyms = ["rh", "rrhh", "asistente", "asistente_rh", "asistente_rrhh", "asistencia", "coordinador", "supervisor", "recursos_humanos"];
    const targets = (targetRoles || []).map((r) => String(r || "").toLowerCase().trim());
    if (targets.length === 0) return true;
    for (const t of targets) {
      if (t === normUserRole) return true;
      if (t === "rh" && rhSynonyms.includes(normUserRole)) return true;
      if (t === "admin" && (normUserRole === "admin" || normUserRole === "superadmin")) return true;
    }
    return false;
  };
  const canCurrentUserActAsSingleApprover = isSingleLevelFlow && matchesRoleOrPermission(firstLevelRoles);
  const isSingleLevelAutoDirectRole = canCurrentUserActAsSingleApprover;
  const decisionBypassEnabledForCurrentUser = () => policyBypassRoles.includes(rolActual);
  const getGrupoLabel = (solicitud = {}) =>
    String(
      solicitud?.grupoNombre ||
      solicitud?.grupo ||
      solicitud?.groupName ||
      solicitud?.group ||
      ""
    ).trim();
  const getGrupoDesdeDni = (dni) => {
    const dniStr = String(dni || "").trim();
    if (!dniStr || !Array.isArray(gruposScope) || gruposScope.length === 0) return "";
    const grupos = gruposScope
      .filter((g) => Array.isArray(g?.members) && g.members.includes(dniStr))
      .map((g) => String(g?.name || "").trim())
      .filter(Boolean);
    return grupos.join(", ");
  };
  const gruposDisponibles = Array.from(
    new Set(
      (Array.isArray(gruposScope) && gruposScope.length > 0
        ? gruposScope.map((g) => String(g?.name || "").trim())
        : solicitudes.map((sol) => getGrupoLabel(sol))
      )
        .filter(Boolean)
    )
  ).sort((a, b) => a.localeCompare(b, "es", { sensitivity: "base" }));

  useEffect(() => {
    const cargarScope = async () => {
      if (!rucEmpresa) return;
      setScopeLoading(true);
      try {
        const scope = await cargarAlcanceGrupoAsistencia({
          db,
          rucEmpresa,
          usuario,
        });
        setDnisPermitidos(scope.dnisPermitidos);
        setGruposScope(Array.isArray(scope?.gruposDisponibles) ? scope.gruposDisponibles : []);
      } catch (error) {
        console.error("Error al cargar alcance de grupos:", error);
        setDnisPermitidos(null);
      } finally {
        setScopeLoading(false);
      }
    };
    cargarScope();
  }, [usuario, rucEmpresa]);

  useEffect(() => {
    if (!scopeLoading && rucEmpresa) {
      cargarSolicitudes();
      cargarSolicitudesAprobacion();
      ensureAttendanceApprovalPolicy();
    }
  }, [scopeLoading, rucEmpresa]);

  // **NUEVO**: Efecto para actualizar "seleccionar todos" cuando filtran
  useEffect(() => {
    setSeleccionados(new Set());
    setSeleccionarTodos(false);
  }, [filtros]);

  const parseDocSnapshot = (docSnap) => {
    const rawData = docSnap.data() || {};
    const pathDni = docSnap.ref?.parent?.parent?.id;
    const docDni = String(rawData.dni || pathDni || "").trim();
    const docRuc = String(rawData.ruc || rawData.rucEmpresa || rucEmpresa || "").trim();

    const fechaSolicitada =
      rawData.fechaSolicitada ||
      rawData.fechaMarcacion ||
      rawData.fechaJornada ||
      rawData.fecha ||
      rawData.timestamp ||
      rawData.fechaReal ||
      rawData.fechaHoraPeru ||
      null;

    const createdAt =
      rawData.createdAt ||
      rawData.fechaCreacion ||
      rawData.timestampLocal ||
      rawData.timestamp ||
      fechaSolicitada ||
      null;

    return {
      id: docSnap.id,
      ...rawData,
      dni: docDni,
      ruc: docRuc,
      nombre: rawData.nombre || rawData.nombres || rawData.empleadoNombre || "",
      apellidos: rawData.apellidos || rawData.empleadoApellidos || "",
      estado: rawData.estado || "Pendiente",
      tipo: rawData.tipo || rawData.tipoRegularizacion || "Regularización",
      fechaSolicitada,
      createdAt,
    };
  };

  const cargarSolicitudes = async (cargarMas = false, filtrosOverride = null) => {
    const filtrosActuales = filtrosOverride || filtros;
    if (scopeLoading) return;
    if (dnisPermitidos instanceof Set && dnisPermitidos.size === 0) {
      setSolicitudes([]);
      setEmpleados([]);
      setTotalRegistros(0);
      setHayMasResultados(false);
      setLoading(false);
      setCargandoMas(false);
      return;
    }
    try {
      if (cargarMas) {
        setCargandoMas(true);
      } else {
        setLoading(true);
        setSolicitudes([]); // Limpiar si es nueva búsqueda
        setLastVisible(null);
      }

      let currentCursor = cargarMas ? lastVisible : null;
      let accumulatedSolicitudes = [];
      let hasMoreInFirestore = true;
      let fetchAttempts = 0;
      const MAX_FETCH_ATTEMPTS = 10;
      const TARGET_MATCHES = 100;
      let reachedPastDateFrom = false;

      const fechaDesdeLimit = filtrosActuales.fechaDesde
        ? new Date(filtrosActuales.fechaDesde + "T00:00:00")
        : null;

      const fechaHastaLimit = filtrosActuales.fechaHasta
        ? new Date(filtrosActuales.fechaHasta + "T23:59:59.999")
        : null;

      // 1. SI FILTRAN O BUSCAN POR UN EMPLEADO ESPECÍFICO (ej. DNI 72458481)
      if (filtrosActuales.empleado) {
        const dniBuscado = String(filtrosActuales.empleado).trim();
        try {
          const directRef = collection(db, `asistencia_regularizacion/${dniBuscado}/regularizacion`);
          const directSnap = await getDocs(directRef);
          directSnap.forEach((docSnap) => {
            const item = parseDocSnapshot(docSnap);
            const est = String(item.estado || "").toLowerCase().trim();
            if (filtrosActuales.estado) {
              const estFiltro = String(filtrosActuales.estado).toLowerCase().trim();
              if (estFiltro === "pendiente" && !["pendiente", "solicitado", "en_espera"].includes(est)) return;
              if (estFiltro === "aprobado" && !["aprobado", "approved"].includes(est)) return;
              if (estFiltro === "rechazado" && !["rechazado", "rejected"].includes(est)) return;
            }
            if (filtrosActuales.tipo && String(item.tipo).toLowerCase() !== String(filtrosActuales.tipo).toLowerCase()) {
              return;
            }
            accumulatedSolicitudes.push(item);
          });
        } catch (e) {
          console.warn("⚠️ Consulta directa por DNI regularizacion no pudo ser completada:", e);
        }
      }

      // 2. CONSULTA GENERAL MEDIANTE COLLECTIONGROUP (si no se han alcanzado los registros deseados)
      if (accumulatedSolicitudes.length < TARGET_MATCHES) {
        while (
          hasMoreInFirestore &&
          fetchAttempts < MAX_FETCH_ATTEMPTS &&
          accumulatedSolicitudes.length < TARGET_MATCHES &&
          !reachedPastDateFrom
        ) {
          fetchAttempts++;
          const queryConstraints = [];

          if (rucEmpresa) {
            const rucNum = Number(rucEmpresa);
            const rucValues = [rucEmpresa];
            if (!isNaN(rucNum) && String(rucNum) === rucEmpresa) {
              rucValues.push(rucNum);
            }
            queryConstraints.push(where("ruc", "in", rucValues));
          }

          if (filtrosActuales.estado) {
            const estFiltro = String(filtrosActuales.estado).toLowerCase().trim();
            if (estFiltro === "pendiente") {
              queryConstraints.push(where("estado", "in", ["Pendiente", "pendiente", "Solicitado", "solicitado"]));
            } else if (estFiltro === "aprobado") {
              queryConstraints.push(where("estado", "in", ["Aprobado", "aprobado"]));
            } else if (estFiltro === "rechazado") {
              queryConstraints.push(where("estado", "in", ["Rechazado", "rechazado"]));
            }
          }

          if (filtrosActuales.empleado) {
            queryConstraints.push(where("dni", "==", String(filtrosActuales.empleado).trim()));
          }

          queryConstraints.push(orderBy("createdAt", "desc"));

          if (currentCursor) {
            queryConstraints.push(startAfter(currentCursor));
          }

          queryConstraints.push(limit(100));

          let querySnapshot = null;
          try {
            const q = query(
              collectionGroup(db, "regularizacion"),
              ...queryConstraints
            );
            querySnapshot = await getDocs(q);
          } catch (errIndex) {
            console.warn("⚠️ query collectionGroup con orderBy/ruc/estado falló (posible falta de índice o campo), ejecutando consulta de respaldo:", errIndex);
            try {
              const fallbackConstraints = [];
              if (filtrosActuales.estado) {
                fallbackConstraints.push(where("estado", "==", filtrosActuales.estado));
              }
              fallbackConstraints.push(limit(100));
              const qFallback = query(collectionGroup(db, "regularizacion"), ...fallbackConstraints);
              querySnapshot = await getDocs(qFallback);
            } catch (errFallback) {
              console.error("❌ Consulta de respaldo también falló:", errFallback);
              hasMoreInFirestore = false;
              break;
            }
          }

          if (!querySnapshot || querySnapshot.empty) {
            hasMoreInFirestore = false;
            break;
          }

          currentCursor = querySnapshot.docs[querySnapshot.docs.length - 1];
          hasMoreInFirestore = querySnapshot.docs.length === 100;

          let countCreatedBeforeDesde = 0;

          querySnapshot.forEach((docSnap) => {
            const data = parseDocSnapshot(docSnap);

            // Evitar duplicados si ya se cargó desde la búsqueda directa por DNI
            if (accumulatedSolicitudes.some((item) => item.id === data.id)) {
              return;
            }

            if (
              dnisPermitidos instanceof Set &&
              !dnisPermitidos.has(String(data.dni || "").trim())
            ) {
              return;
            }

            const fechaSolicitud = parseFecha(data.fechaSolicitada);
            const fechaCreacion = parseFecha(data.createdAt);

            if (fechaDesdeLimit) {
              if (fechaCreacion && fechaCreacion < fechaDesdeLimit) {
                countCreatedBeforeDesde++;
              }
              if (fechaSolicitud && fechaSolicitud < fechaDesdeLimit) {
                return;
              }
            }

            if (fechaHastaLimit && fechaSolicitud) {
              if (fechaSolicitud > fechaHastaLimit) return;
            }

            if (filtrosActuales.grupo) {
              const grupoSolicitud = getGrupoDesdeDni(data?.dni) || getGrupoLabel(data);
              const gruposSolicitud = String(grupoSolicitud)
                .split(",")
                .map((item) => item.trim())
                .filter(Boolean);
              if (!gruposSolicitud.includes(filtrosActuales.grupo)) return;
            }

            accumulatedSolicitudes.push(data);
          });

          if (fechaDesdeLimit && countCreatedBeforeDesde > 0) {
            reachedPastDateFrom = true;
          }
        }
      }

      // Ordenar resultados acumulados por fecha (más reciente primero)
      accumulatedSolicitudes.sort((a, b) => {
        const dA = parseFecha(a.createdAt || a.fechaSolicitada)?.getTime() || 0;
        const dB = parseFecha(b.createdAt || b.fechaSolicitada)?.getTime() || 0;
        return dB - dA;
      });

      setLastVisible(currentCursor);
      setHayMasResultados(hasMoreInFirestore && !reachedPastDateFrom);

      if (cargarMas) {
        setSolicitudes(prev => {
          const nuevos = accumulatedSolicitudes.filter(s => !prev.some(p => p.id === s.id));
          return [...prev, ...nuevos];
        });
      } else {
        setSolicitudes(accumulatedSolicitudes);
      }

      const totalCount = accumulatedSolicitudes.length;
      setTotalRegistros(prev => cargarMas ? prev + totalCount : totalCount);
      setPrimeraVez(false);

      // Generar lista de empleados únicos considerando los nuevos datos
      setEmpleados(prevEmpleados => {
        const dniVistos = new Set(cargarMas ? prevEmpleados.map(e => e.dni) : []);
        const empleadosNuevos = [...(cargarMas ? prevEmpleados : [])];

        filtrarPorDnisPermitidos(
          accumulatedSolicitudes,
          (solicitud) => solicitud?.dni,
          dnisPermitidos
        ).forEach((solicitud) => {
          if (solicitud.dni && !dniVistos.has(solicitud.dni)) {
            dniVistos.add(solicitud.dni);
            empleadosNuevos.push({
              dni: solicitud.dni,
              nombres: solicitud.nombre || "",
              apellidos: solicitud.apellidos || "",
            });
          }
        });

        empleadosNuevos.sort((a, b) => {
          const nomA = `${a.apellidos}, ${a.nombres}`.trim().toLowerCase();
          const nomB = `${b.apellidos}, ${b.nombres}`.trim().toLowerCase();
          return nomA.localeCompare(nomB, "es", { sensitivity: "base" });
        });

        return empleadosNuevos;
      });

      if (primeraVez && accumulatedSolicitudes.length === 0) {
        Swal.fire({
          icon: "info",
          title: "Sin Solicitudes",
          text: "No se encontraron solicitudes que coincidan con los filtros.",
          timer: 3000,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      console.error("Error al cargar solicitudes:", error);
      mostrarError("Error al cargar solicitudes de regularización");
    } finally {
      setLoading(false);
    }
  };

  const ensureAttendanceApprovalPolicy = async () => {
    if (!rucEmpresa) return;
    if (!["admin", "superAdmin"].includes(String(usuario?.rol || ""))) return;
    try {
      const policyRef = doc(db, `governance/${rucEmpresa}/approvalPolicies/${ATTENDANCE_APPROVAL_PROCESS}`);
      const existing = await getDoc(policyRef);
      if (existing.exists()) return;
      const callable = httpsCallable(functions, "upsertTenantApprovalPolicy");
      await callable({
        tenantId: rucEmpresa,
        processType: ATTENDANCE_APPROVAL_PROCESS,
        policy: {
          levels: [
            { level: 1, roles: ["rh"], minApprovers: 1 },
            { level: 2, roles: ["admin"], minApprovers: 1 },
          ],
          constraints: {
            separationOfDuties: true,
            sameApproverAcrossLevels: false,
            allowRequesterApproval: true,
          },
        },
      });
    } catch (error) {
      console.error("No se pudo asegurar política de aprobación de asistencia:", error);
    }
  };

  const cargarSolicitudesAprobacion = async () => {
    if (!rucEmpresa) return;
    // Cargar política SIEMPRE, incluso si falla la lectura de approvalRequests
    try {
      const policyRef = doc(db, `governance/${rucEmpresa}/approvalPolicies/${ATTENDANCE_APPROVAL_PROCESS}`);
      const policySnap = await getDoc(policyRef);
      if (policySnap.exists()) {
        const policyData = policySnap.data() || {};
        const levels = Array.isArray(policyData.levels) ? policyData.levels : [];
        const normalized = levels
          .map((lvl) => ({
            level: Number(lvl.level || 1),
            roles: Array.isArray(lvl.roles) ? lvl.roles.map((r) => String(r || "").trim().toLowerCase()).filter(Boolean) : [],
            minApprovers: Number(lvl.minApprovers || 1),
          }))
          .sort((a, b) => a.level - b.level);
        if (normalized.length) setPolicyLevels(normalized);
        const bypassRoles = Array.isArray(policyData?.constraints?.bypassRoles)
          ? policyData.constraints.bypassRoles.map((r) => String(r || "").trim().toLowerCase()).filter(Boolean)
          : [];
        setPolicyBypassRoles(bypassRoles);
      }
    } catch (error) {
      console.error("Error cargando política de aprobación de asistencia:", error);
    }

    try {
      const q = query(
        collection(db, `governance/${rucEmpresa}/approvalRequests`),
        where("processType", "==", ATTENDANCE_APPROVAL_PROCESS),
        orderBy("updatedAt", "desc"),
        limit(300)
      );
      const snap = await getDocs(q);
      const map = new Map();
      snap.forEach((d) => {
        const data = { id: d.id, ...d.data() };
        const key = String(data.resourceId || "").trim();
        if (!key) return;
        if (!map.has(key)) map.set(key, data);
      });
      setApprovalRequests(map);
    } catch (error) {
      console.error("Error cargando solicitudes de aprobación por niveles:", error);
    }
  };

  const getApprovalRequestFor = (solicitud) => {
    if (!solicitud?.id) return null;
    return approvalRequests.get(String(solicitud.id)) || null;
  };

  const canUserActOnSolicitud = (solicitud) => {
    if (esSuperAdmin) return true;
    const flow = String(getApprovalRequestFor(solicitud)?.status || solicitud?.approvalStatus || "").trim();
    const currentLevelMatch = flow.match(/^pending_l(\d+)$/i);
    const canBypass = policyBypassRoles.includes(rolActual) || rolActual === "admin" || rolActual === "superadmin" || matchesRoleOrPermission();

    if (currentLevelMatch) {
      const levelNumber = Number(currentLevelMatch[1]);
      const levelRoles = (policyLevels.find((lvl) => lvl.level === levelNumber)?.roles || []).map((r) => String(r).toLowerCase());
      return matchesRoleOrPermission(levelRoles) || canBypass;
    }
    if (flow.startsWith("pending_")) return canBypass;
    const est = String(solicitud?.estado || "").toLowerCase().trim();
    if (est === "pendiente" || est === "solicitado" || est === "en_espera") {
      const firstLevelRoles = (policyLevels.find((lvl) => lvl.level === 1)?.roles || []).map((r) => String(r).toLowerCase());
      return matchesRoleOrPermission(firstLevelRoles) || canBypass;
    }
    return false;
  };

  const getUserActionLabel = (solicitud) => {
    if (esSuperAdmin) return "SuperAdmin: Acceso total";
    const flow = String(getApprovalRequestFor(solicitud)?.status || solicitud?.approvalStatus || "").trim();
    const currentLevelMatch = flow.match(/^pending_l(\d+)$/i);
    const canBypass = policyBypassRoles.includes(rolActual) || rolActual === "admin" || matchesRoleOrPermission();
    if (currentLevelMatch) {
      const levelNumber = Number(currentLevelMatch[1]);
      const levelRoles = (policyLevels.find((lvl) => lvl.level === levelNumber)?.roles || []).map((r) => String(r).toLowerCase());
      if (matchesRoleOrPermission(levelRoles)) return `Te toca L${levelNumber}`;
      if (canBypass) return "Puede bypass";
    }
    const est = String(solicitud?.estado || "").toLowerCase().trim();
    if (!flow && (est === "pendiente" || est === "solicitado")) return "Acción disponible";
    return "No te corresponde";
  };

  const solicitudesAccionables = solicitudes.filter((s) => canUserActOnSolicitud(s));
  const solicitudesVisibles = esSuperAdmin ? solicitudes : (soloMiBandeja ? solicitudesAccionables : solicitudes);

  // **NUEVO**: Toggle selección individual
  const toggleSeleccion = (id) => {
    const nuevosSeleccionados = new Set(seleccionados);
    if (nuevosSeleccionados.has(id)) {
      nuevosSeleccionados.delete(id);
    } else {
      nuevosSeleccionados.add(id);
    }
    setSeleccionados(nuevosSeleccionados);
  };

  // **NUEVO**: Toggle seleccionar todos (solo accionables para el rol actual)
  const toggleSeleccionarTodos = () => {
    if (seleccionarTodos) {
      setSeleccionados(new Set());
    } else {
      const base = soloMiBandeja ? solicitudesAccionables : solicitudesAccionables;
      const pendientesIds = base
        .map((s) => s.id);
      setSeleccionados(new Set(pendientesIds));
    }
    setSeleccionarTodos(!seleccionarTodos);
  };



  // **NUEVO**: Helper para generar datos de asistencia y aprobación
  const generarDatosAprobacion = (solicitud, empleadosList, usuarioActual) => {
    const fechaSolicitada = parseFecha(solicitud.fechaSolicitada) || new Date();
    let fechaJornada;
    let cruzaMedianoche = false;
    let tipoTurno = "diurno";

    if (solicitud.tipo === "Salida") {
      const hora = fechaSolicitada.getHours();

      if (hora >= 0 && hora < 8) {
        const fechaJornadaDate = new Date(fechaSolicitada);
        fechaJornadaDate.setDate(fechaJornadaDate.getDate() - 1);
        fechaJornada = format(fechaJornadaDate, "yyyy-MM-dd");
        cruzaMedianoche = true;

        if (hora >= 0 && hora <= 3) {
          tipoTurno = "vespertino";
        } else {
          tipoTurno = "nocturno";
        }
      } else {
        fechaJornada = format(fechaSolicitada, "yyyy-MM-dd");

        if (hora >= 22) {
          tipoTurno = "nocturno";
        } else if (hora >= 18 && hora < 22) {
          tipoTurno = "vespertino";
        }
      }
    } else if (solicitud.tipo === "Ingreso") {
      const hora = fechaSolicitada.getHours();
      fechaJornada = format(fechaSolicitada, "yyyy-MM-dd");

      if (hora >= 16 && hora < 20) {
        tipoTurno = "vespertino";
        cruzaMedianoche = true;
      } else if (hora >= 20 && hora <= 23) {
        tipoTurno = "nocturno";
        cruzaMedianoche = true;
      } else if (hora >= 0 && hora < 6) {
        tipoTurno = "nocturno";
      }
    }

    const fechaMarcacion = format(fechaSolicitada, "HH:mm:ss");
    const periodo = format(fechaSolicitada, "MM");
    const ano = String(format(fechaSolicitada, "yyyy"));

    const empleado = (empleadosList || []).find((emp) => emp.dni === solicitud.dni);
    const nombreEmpleado = empleado ? empleado.nombres : solicitud.nombre || "";
    const apellidosEmpleado = empleado ? empleado.apellidos : solicitud.apellidos || "";

    if (!empleado && !solicitud.nombre) {
      console.warn(`No se encontró información del empleado con DNI ${solicitud.dni}`);
    }

    const fechaParaId = format(fechaSolicitada, "yyyy-MM-dd");
    const horaParaId = format(fechaSolicitada, "HHmmss");
    const tipoParaId = String(solicitud.tipo || "registro").toLowerCase();
    const documentId = `${fechaParaId}_${tipoParaId}_${horaParaId}_regularizacion`;

    // Campos adicionales para el registro
    const registroAsistencia = {
      activo: true,
      ano: ano,
      apellidos: apellidosEmpleado || "",
      cargo: solicitud.cargo || "",
      centro: {
        centroNombre: solicitud.centroNombre || "",
        latitud: 0,
        longitud: 0,
        radio: 0,
      },
      createdAt: new Date().toISOString(),
      cruzaMedianoche: !!cruzaMedianoche,
      distanciaCentro: 0,
      dni: solicitud.dni || "",
      email: solicitud.email || "",
      esJornadaNocturna: tipoTurno === "nocturno" || tipoTurno === "vespertino",
      esRegistroRetroactivo: true,
      fechaHoraPeru: format(new Date(), "yyyy-MM-dd HH:mm:ss"),
      fechaJornada: fechaJornada,
      fechaMarcacion: fechaMarcacion,
      fechaReal: fechaSolicitada.toISOString(),
      metadata: {
        deviceId: "REGULARIZACION_ADMIN",
        isHighAccuracy: true,
        origen: "regularizacion-aprobada",
        precision: 0,
        ubicacionSeleccionada: "regularizacion",
        version: "admin-1.0.0",
        procesadoPor: usuarioActual?.email || "",
        fechaProcesamiento: new Date().toISOString(),
      },
      nombre: nombreEmpleado || "",
      periodo: periodo,
      ruc: solicitud.ruc || usuarioActual?.ruc || "",
      timestamp: fechaSolicitada,
      timestampLocal: fechaSolicitada.toISOString(),
      tipo: solicitud.tipo || "",
      ubicacion: {
        confiabilidad: "alta",
        latitud: 0,
        longitud: 0,
        movimientoSospechoso: false,
        muestrasPromediadas: 0,
        precision: 0,
        proveedorGPS: "REGULARIZACION",
        zonaHoraria: "America/Lima",
      },
      validacion: {
        advertencias: cruzaMedianoche ? [`Marcación de turno ${tipoTurno} que cruza medianoche`] : [],
        errores: [],
        esValida: true,
        estado: "valido",
        fechaValidacion: new Date().toISOString(),
        tipoTurno: tipoTurno,
        observaciones: `Regularización ${String(solicitud.tipo || "").toLowerCase()} - ${tipoTurno}${cruzaMedianoche ? ' (cruza medianoche)' : ''}`,
      },
      esRegularizacion: true,
      solicitudRegularizacionId: solicitud.id,
      aprobadoPor: usuarioActual?.email || "",
      fechaAprobacion: new Date(),
      justificacionRegularizacion: solicitud.justificacion || "",

      configuracionTurno: {
        tipoDetectado: tipoTurno,
        cruzaMedianoche: cruzaMedianoche,
        fechaJornadaCalculada: fechaJornada,
        horaOriginal: format(fechaSolicitada, "HH:mm:ss"),
        fechaOriginal: format(fechaSolicitada, "yyyy-MM-dd"),
        razonAsignacion: cruzaMedianoche ?
          (solicitud.tipo === "Salida" ?
            `Salida ${tipoTurno} - asignada a jornada del día anterior (inicio turno)` :
            `Ingreso ${tipoTurno} - será la fecha base para toda la jornada`) :
          "Turno normal - misma fecha de jornada",
      }
    };

    const observacionesAprobacion = [
      `Regularización ${String(solicitud.tipo || "").toLowerCase()} aprobada`,
      `Tipo de turno: ${tipoTurno}`,
      `Fecha jornada asignada: ${fechaJornada}`,
      cruzaMedianoche ? `Turno ${tipoTurno} que cruza medianoche` : `Turno ${tipoTurno} normal`,
      `Registro creado con ID: ${documentId}`
    ].join(' | ');

    return {
      registroAsistencia,
      documentId,
      fechaJornada,
      tipoTurno,
      cruzaMedianoche,
      observacionesAprobacion
    };
  };

  const aprobarSolicitudDirecta = async (solicitud, options = {}) => {
    const silent = options?.silent === true;
    try {
      const datosAprobacion = generarDatosAprobacion(solicitud, empleados, usuario);
      const {
        registroAsistencia,
        documentId,
        fechaJornada,
        tipoTurno,
        cruzaMedianoche,
        observacionesAprobacion
      } = datosAprobacion;

      // Crear registro de asistencia
      const asistenciaRef = doc(db, `asistencia/${solicitud.dni}/registros`, documentId);
      await setDoc(asistenciaRef, registroAsistencia);
      console.log("✅ Registro de asistencia creado exitosamente");

      // Actualizar solicitud de regularización
      const solicitudRef = doc(
        db,
        `asistencia_regularizacion/${solicitud.dni}/regularizacion`,
        solicitud.id
      );

      await updateDoc(solicitudRef, {
        estado: "Aprobado",
        approvalStatus: "approved",
        aprobadoPor: usuario?.email || "",
        fechaAprobacion: new Date(),
        observacionesAprobacion: observacionesAprobacion,
        registroAsistenciaId: documentId,
        fechaJornadaAsignada: fechaJornada,
        tipoTurnoDetectado: tipoTurno,
      });

      const getTurnoIcon = (tipo) => {
        switch (tipo) {
          case "vespertino": return "🌅";
          case "nocturno": return "🌙";
          default: return "☀️";
        }
      };

      const fechaJornadaParaMensaje = new Date(fechaJornada + "T12:00:00");

      const mensajeExito = [
        `La solicitud de ${solicitud.tipo.toLowerCase()} ha sido aprobada correctamente.`,
        `Fecha de jornada asignada: ${format(fechaJornadaParaMensaje, "dd/MM/yyyy")}`,
        `${getTurnoIcon(tipoTurno)} Turno ${tipoTurno} detectado`,
        cruzaMedianoche ? "⚠️ Este turno cruza medianoche - ambas marcaciones Ingreso y Salida tendrán la misma fecha de jornada" : ""
      ].filter(Boolean).join('\n');

      if (!silent) {
        Swal.fire({
          icon: "success",
          title: "Solicitud Aprobada",
          html: mensajeExito.replace(/\n/g, '<br>'),
          confirmButtonText: "Entendido"
        });
      }

      cargarSolicitudes();
      setShowModal(false);

    } catch (error) {
      console.error("❌ Error al aprobar solicitud:", error);
      if (!silent) {
        Swal.fire({
          icon: "error",
          title: "Error al aprobar solicitud",
          text: error.message || "Ocurrió un error inesperado",
          confirmButtonText: "Cerrar"
        });
      }
      throw error;
    }
  };

  const rechazarSolicitudDirecta = async (solicitud, motivoOverride = "", options = {}) => {
    const silent = options?.silent === true;
    const motivoFinal = String(motivoOverride || motivoRechazo || "").trim();
    if (!motivoFinal) {
      mostrarError("Debe proporcionar un motivo para el rechazo");
      return;
    }

    try {
      const solicitudRef = doc(
        db,
        `asistencia_regularizacion/${solicitud.dni}/regularizacion`,
        solicitud.id
      );
      await updateDoc(solicitudRef, {
        estado: "Rechazado",
        approvalStatus: "rejected",
        rechazadoPor: usuario?.email || "",
        fechaRechazo: new Date(),
        motivoRechazo: motivoFinal,
      });

      if (!silent) {
        Swal.fire({
          icon: "success",
          title: "Solicitud Rechazada",
          text: "La solicitud ha sido rechazada correctamente",
        });
      }

      cargarSolicitudes();
      setShowModal(false);
      setMotivoRechazo("");
    } catch (error) {
      console.error("Error al rechazar solicitud:", error);
      if (!silent) mostrarError("Error al rechazar la solicitud");
      throw error;
    }
  };

  const solicitarYProcesarAprobacionNivel = async (
    solicitud,
    decision,
    comment = "",
    requestReasonOverride = "",
    options = {}
  ) => {
    const skipCreatedAlert = options?.skipCreatedAlert === true;
    const solicitudRef = doc(
      db,
      `asistencia_regularizacion/${solicitud.dni}/regularizacion`,
      solicitud.id
    );

    let request = getApprovalRequestFor(solicitud);
    if (!request || !String(request.status || "").startsWith("pending_l")) {
      const requestReason =
        String(requestReasonOverride || "").trim() ||
        `Regularización ${solicitud.tipo} - ${solicitud.dni}`;
      const submit = httpsCallable(functions, "submitApprovalRequest");
      try {
        const created = await submit({
          tenantId: rucEmpresa,
          processType: ATTENDANCE_APPROVAL_PROCESS,
          resourceType: "asistencia_regularizacion",
          resourceId: solicitud.id,
          reason: requestReason,
          payloadSnapshot: {
            dni: solicitud.dni,
            tipo: solicitud.tipo,
            nombre: solicitud.nombre,
            apellidos: solicitud.apellidos,
            fechaSolicitada: solicitud.fechaSolicitada?.toDate?.()?.toISOString?.() || null,
          },
        });
        request = {
          id: created?.data?.requestId,
          status: created?.data?.status,
        };
      } catch (submitError) {
        const msg = String(submitError?.message || "");
        if (!msg.includes("Ya existe una solicitud pendiente")) throw submitError;
        const existingSnap = await getDocs(query(
          collection(db, `governance/${rucEmpresa}/approvalRequests`),
          where("processType", "==", ATTENDANCE_APPROVAL_PROCESS),
          where("resourceId", "==", solicitud.id)
        ));
        if (existingSnap.empty) throw submitError;
        const existingDocs = existingSnap.docs
          .map((d) => ({ id: d.id, data: d.data() || {} }))
          .sort((a, b) => {
            const aTime = a.data?.updatedAt?.toMillis?.() || a.data?.createdAt?.toMillis?.() || 0;
            const bTime = b.data?.updatedAt?.toMillis?.() || b.data?.createdAt?.toMillis?.() || 0;
            return bTime - aTime;
          });
        const existing = existingDocs[0];
        request = {
          id: existing.id,
          status: String(existing.data?.status || "pending_l1"),
        };
      }
      await updateDoc(solicitudRef, {
        approvalRequestId: request.id,
        approvalStatus: request.status || "pending_l1",
        updatedAt: serverTimestamp(),
      });
      await cargarSolicitudesAprobacion();
      if (!skipCreatedAlert) {
        await showApprovalRequestCreatedAlert({
          pendingSubject: "La solicitud de regularización",
          firstLevelLabel: approvalLevelsForModal[0]
            ? `${approvalLevelsForModal[0].role} (${approvalLevelsForModal[0].level})`
            : "L1",
          secondLevelLabel: approvalLevelsForModal[1]
            ? `${approvalLevelsForModal[1].role} (${approvalLevelsForModal[1].level})`
            : undefined,
        });
      }
    }

    const decide = httpsCallable(functions, "decideApprovalRequest");
    const response = await decide({
      tenantId: rucEmpresa,
      requestId: request.id,
      decision,
      comment,
    });
    const newStatus = String(response?.data?.status || "");
    await updateDoc(solicitudRef, {
      approvalRequestId: request.id,
      approvalStatus: newStatus,
      updatedAt: serverTimestamp(),
    });
    await cargarSolicitudesAprobacion();
    return newStatus;
  };

  const aprobarSolicitud = async (solicitud) => {
    try {
      setProcesando(true);
      if (isSingleLevelAutoDirectRole) {
        await aprobarSolicitudDirecta(solicitud);
        return;
      }
      if (canCurrentUserActAsSingleApprover) {
        await aprobarSolicitudDirecta(solicitud);
        return;
      }
      if (isSingleLevelFlow) {
        mostrarError("En flujo de 1 nivel solo puede aprobar/rechazar el rol definido en la política.");
        return;
      }
      let requestReason = "";
      const request = getApprovalRequestFor(solicitud);
      const isNewRequest = !request || !String(request.status || "").startsWith("pending_l");
      const canBypassOnApprove = isNewRequest && decisionBypassEnabledForCurrentUser();
      const autoDirectSingleLevel = isNewRequest && canCurrentUserActAsSingleApprover;
      if (isNewRequest && !autoDirectSingleLevel && !canBypassOnApprove) {
        const result = await requestApprovalWithReasonModal({
          title: isSingleLevelFlow ? "Aprobación de regularización" : "Solicitar aprobación de regularización",
          actionLabel: isSingleLevelFlow ? "la aprobación de la regularización de asistencia" : "la regularización de asistencia",
          inputLabel: "Motivo de la solicitud",
          inputPlaceholder: "Explique por qué corresponde aprobar esta regularización...",
          confirmButtonText: isSingleLevelFlow ? "Aprobar" : "Enviar a flujo de aprobación",
          levels: approvalLevelsForModal,
          includeAdminBypassNote: true,
        });
        if (!result.isConfirmed) return;
        requestReason = String(result.value || "").trim();
      } else if (autoDirectSingleLevel) {
        requestReason = `Aprobación directa en flujo de 1 nivel por ${usuario?.email || "usuario"}`;
      } else if (canBypassOnApprove) {
        requestReason = `Aprobación por bypass de ${rolActual} (${usuario?.email || "usuario"})`;
      }

      const status = await solicitarYProcesarAprobacionNivel(
        solicitud,
        "approve",
        "Aprobación de nivel",
        requestReason,
        { skipCreatedAlert: autoDirectSingleLevel || canBypassOnApprove }
      );

      if (status === "approved") {
        await aprobarSolicitudDirecta(solicitud);
        return;
      }

      Swal.fire({
        icon: "info",
        title: "Aprobación registrada",
        text: (() => {
          const levelMatch = String(status || "").match(/^pending_l(\d+)$/i);
          if (levelMatch) {
            return `Solicitud registrada. Pendiente aprobación de Nivel ${levelMatch[1]}.`;
          }
          return "Solicitud registrada en flujo de aprobación.";
        })(),
      });
      await cargarSolicitudes();
    } catch (error) {
      console.error("Error en flujo de aprobación:", error);
      Swal.fire("Error", error?.message || "No se pudo procesar la aprobación por niveles.", "error");
    } finally {
      setProcesando(false);
    }
  };

  const rechazarSolicitud = async (solicitud) => {
    if (!motivoRechazo.trim()) {
      mostrarError("Debe proporcionar un motivo para el rechazo");
      return;
    }
    try {
      setProcesando(true);
      if (isSingleLevelAutoDirectRole) {
        await rechazarSolicitudDirecta(solicitud, motivoRechazo);
        return;
      }
      if (canCurrentUserActAsSingleApprover) {
        await rechazarSolicitudDirecta(solicitud, motivoRechazo);
        return;
      }
      if (isSingleLevelFlow) {
        mostrarError("En flujo de 1 nivel solo puede aprobar/rechazar el rol definido en la política.");
        return;
      }
      let requestReason = "";
      const request = getApprovalRequestFor(solicitud);
      const isNewRequest = !request || !String(request.status || "").startsWith("pending_l");
      const canBypassOnReject = isNewRequest && decisionBypassEnabledForCurrentUser();
      const autoDirectSingleLevel = isNewRequest && canCurrentUserActAsSingleApprover;
      if (isNewRequest && !autoDirectSingleLevel && !canBypassOnReject) {
        const result = await requestApprovalWithReasonModal({
          title: isSingleLevelFlow ? "Rechazo de regularización" : "Solicitar flujo de rechazo",
          actionLabel: isSingleLevelFlow ? "el rechazo de la regularización de asistencia" : "el rechazo de regularización",
          inputLabel: "Motivo base de la solicitud",
          inputPlaceholder: "Explique por qué esta regularización debe pasar por flujo de rechazo...",
          confirmButtonText: isSingleLevelFlow ? "Rechazar" : "Enviar a flujo de aprobación",
          levels: approvalLevelsForModal,
          includeAdminBypassNote: true,
        });
        if (!result.isConfirmed) return;
        requestReason = String(result.value || "").trim();
      } else if (autoDirectSingleLevel) {
        requestReason = `Rechazo directo en flujo de 1 nivel por ${usuario?.email || "usuario"}`;
      } else if (canBypassOnReject) {
        requestReason = `Rechazo por bypass de ${rolActual} (${usuario?.email || "usuario"})`;
      }

      const status = await solicitarYProcesarAprobacionNivel(
        solicitud,
        "reject",
        motivoRechazo,
        requestReason,
        { skipCreatedAlert: autoDirectSingleLevel || canBypassOnReject }
      );
      if (status === "rejected") {
        await rechazarSolicitudDirecta(solicitud);
        return;
      }
      await cargarSolicitudes();
    } catch (error) {
      console.error("Error en flujo de rechazo:", error);
      Swal.fire("Error", error?.message || "No se pudo procesar el rechazo por niveles.", "error");
    } finally {
      setProcesando(false);
    }
  };



  // Acciones masivas usando el mismo flujo de políticas que la acción individual
  const procesarLoteConPoliticas = async (items, accion, motivo = "", requestReason = "") => {
    setMostrarProgreso(true);
    setProgresoActual(0);
    const total = items.length;
    let procesados = 0;
    let exitosos = 0;
    let fallidos = 0;
    const errores = [];

    try {
      for (const sol of items) {
        try {
          const status = await solicitarYProcesarAprobacionNivel(
            sol,
            accion === "aprobar" ? "approve" : "reject",
            accion === "aprobar" ? "Aprobación masiva por nivel" : String(motivo || "Rechazo masivo"),
            requestReason
          );

          if (accion === "aprobar" && status === "approved") {
            await aprobarSolicitudDirecta(sol, { silent: true });
          }
          if (accion === "rechazar" && status === "rejected") {
            await rechazarSolicitudDirecta(sol, motivo || "Rechazo masivo", { silent: true });
          }

          exitosos += 1;
        } catch (error) {
          fallidos += 1;
          const nombre = sol?.nombreEmpleado || `${sol?.apellidos || ""} ${sol?.nombre || ""}`.trim() || sol?.dni || sol?.id;
          const msg = error?.message || "Error no identificado";
          errores.push(`${nombre}: ${msg}`);
        } finally {
          procesados += 1;
        }

        setProgresoActual(Math.round((procesados / total) * 100));
        setMensajeProgreso(`Procesando ${procesados} de ${total}...`);
        await new Promise(r => setTimeout(r, 100));
      }

      if (fallidos > 0) {
        console.warn("Procesamiento masivo completado con errores:", {
          exitosos,
          fallidos,
          errores: errores.slice(0, 5),
        });
      }
      await cargarSolicitudes();
      await cargarSolicitudesAprobacion();

    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Ocurrió un error en el procesamiento masivo", "error");
    } finally {
      setMostrarProgreso(false);
      setSeleccionados(new Set()); // Limpiar selección
      setSeleccionarTodos(false);
    }
  };

  const aprobarSeleccionados = async () => {
    const list = solicitudes.filter(s => seleccionados.has(s.id));
    if (list.length === 0) return;

    if (isSingleLevelAutoDirectRole) {
      setMostrarProgreso(true);
      setProgresoActual(0);
      setMensajeProgreso("Procesando aprobaciones...");
      const total = list.length;
      let procesados = 0;
      let exitosos = 0;
      let fallidos = 0;
      const errores = [];

      try {
        for (const sol of list) {
          try {
            await aprobarSolicitudDirecta(sol, { silent: true });
            exitosos += 1;
          } catch (error) {
            fallidos += 1;
            const nombre = sol?.nombreEmpleado || `${sol?.apellidos || ""} ${sol?.nombre || ""}`.trim() || sol?.dni || sol?.id;
            const msg = error?.message || "Error no identificado";
            errores.push(`${nombre}: ${msg}`);
          } finally {
            procesados += 1;
            setProgresoActual(Math.round((procesados / total) * 100));
            setMensajeProgreso(`Procesando ${procesados} de ${total}...`);
            await new Promise(r => setTimeout(r, 80));
          }
        }

        if (fallidos > 0) {
          console.warn("Aprobación masiva completada con errores:", {
            exitosos,
            fallidos,
            errores: errores.slice(0, 5),
          });
        }
        await cargarSolicitudes();
      } finally {
        setMostrarProgreso(false);
        setSeleccionados(new Set());
        setSeleccionarTodos(false);
      }
      return;
    }
    if (isSingleLevelFlow) {
      mostrarError("En flujo de 1 nivel solo puede aprobar/rechazar el rol definido en la política.");
      return;
    }

    const reasonPrompt = await requestApprovalWithReasonModal({
      title: "Aprobación masiva por niveles",
      actionLabel: "la aprobación masiva de regularizaciones",
      inputLabel: "Motivo base de la solicitud",
      inputPlaceholder: "Explique la razón general de la aprobación masiva...",
      confirmButtonText: "Enviar a flujo de aprobación",
      levels: approvalLevelsForModal,
      includeAdminBypassNote: true,
    });
    if (!reasonPrompt.isConfirmed) return;
    const requestReason = String(reasonPrompt.value || "").trim();

    const result = await Swal.fire({
      title: 'Aprobar Seleccionados',
      text: `¿Estás seguro de aprobar ${list.length} solicitudes?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, aprobar',
      cancelButtonText: 'Cancelar'
    });

    if (result.isConfirmed) {
      await procesarLoteConPoliticas(list, 'aprobar', "", requestReason);
    }
  };

  const rechazarSeleccionados = async () => {
    const list = solicitudes.filter(s => seleccionados.has(s.id));
    if (list.length === 0) return;

    if (isSingleLevelAutoDirectRole) {
      const { value: motivo } = await Swal.fire({
        title: "Rechazar Seleccionados",
        input: "textarea",
        inputLabel: "Motivo del rechazo (general)",
        inputPlaceholder: "Ingrese el motivo...",
        showCancelButton: true,
        confirmButtonText: "Rechazar Todo",
        cancelButtonColor: "#d33",
        inputValidator: (value) => {
          if (!value) return "Debes escribir un motivo";
        }
      });

      if (!motivo) return;

      setMostrarProgreso(true);
      setProgresoActual(0);
      setMensajeProgreso("Procesando rechazos...");
      const total = list.length;
      let procesados = 0;
      let exitosos = 0;
      let fallidos = 0;
      const errores = [];

      try {
        for (const sol of list) {
          try {
            await rechazarSolicitudDirecta(sol, motivo, { silent: true });
            exitosos += 1;
          } catch (error) {
            fallidos += 1;
            const nombre = sol?.nombreEmpleado || `${sol?.apellidos || ""} ${sol?.nombre || ""}`.trim() || sol?.dni || sol?.id;
            const msg = error?.message || "Error no identificado";
            errores.push(`${nombre}: ${msg}`);
          } finally {
            procesados += 1;
            setProgresoActual(Math.round((procesados / total) * 100));
            setMensajeProgreso(`Procesando ${procesados} de ${total}...`);
            await new Promise(r => setTimeout(r, 80));
          }
        }

        if (fallidos > 0) {
          console.warn("Rechazo masivo completado con errores:", {
            exitosos,
            fallidos,
            errores: errores.slice(0, 5),
          });
        }
        await cargarSolicitudes();
      } finally {
        setMostrarProgreso(false);
        setSeleccionados(new Set());
        setSeleccionarTodos(false);
      }
      return;
    }
    if (isSingleLevelFlow) {
      mostrarError("En flujo de 1 nivel solo puede aprobar/rechazar el rol definido en la política.");
      return;
    }

    const reasonPrompt = await requestApprovalWithReasonModal({
      title: "Rechazo masivo por niveles",
      actionLabel: "el rechazo masivo de regularizaciones",
      inputLabel: "Motivo base para abrir el flujo",
      inputPlaceholder: "Explique la razón general del rechazo masivo...",
      confirmButtonText: "Enviar a flujo de aprobación",
      levels: approvalLevelsForModal,
      includeAdminBypassNote: true,
    });
    if (!reasonPrompt.isConfirmed) return;
    const requestReason = String(reasonPrompt.value || "").trim();

    const { value: motivo } = await Swal.fire({
      title: "Rechazar Seleccionados",
      input: "textarea",
      inputLabel: "Motivo del rechazo (general)",
      inputPlaceholder: "Ingrese el motivo...",
      showCancelButton: true,
      confirmButtonText: "Rechazar Todo",
      cancelButtonColor: "#d33",
      inputValidator: (value) => {
        if (!value) return "Debes escribir un motivo";
      }
    });

    if (motivo) {
      await procesarLoteConPoliticas(list, 'rechazar', motivo, requestReason);
    }
  };

  const verDetalle = (solicitud) => {
    setSolicitudSeleccionada(solicitud);
    setShowModal(true);
    setMotivoRechazo("");
  };

  const obtenerNombreEmpleado = (dni) => {
    const empleado = empleados.find((emp) => emp.dni === dni);
    return empleado
      ? `${empleado.nombres} ${empleado.apellidos}`
      : "Empleado no encontrado";
  };

  const getBadgeVariant = (estado = "") => {
    const norm = String(estado || "").toLowerCase().trim();
    if (norm === "pendiente" || norm === "solicitado" || norm === "en_espera") return "warning";
    if (norm.startsWith("pending_l")) return "info";
    if (norm === "aprobado" || norm === "approved") return "success";
    if (norm === "rechazado" || norm === "rejected") return "danger";
    return "secondary";
  };

  const getEstadoVisual = (solicitud) => {
    const flowStatus = String(
      getApprovalRequestFor(solicitud)?.status || solicitud?.approvalStatus || ""
    ).trim();
    const pendingMatch = flowStatus.match(/^pending_l(\d+)$/i);
    if (pendingMatch) {
      const levelNumber = Number(pendingMatch[1]);
      const levelRoles = (policyLevels.find((lvl) => lvl.level === levelNumber)?.roles || [])
        .map((r) => toTitleCase(r))
        .join(" / ");
      return `Pendiente ${levelRoles || "Nivel"} (L${levelNumber})`;
    }
    if (flowStatus === "approved" || String(solicitud?.estado).toLowerCase() === "aprobado") return "Aprobado";
    if (flowStatus === "rejected" || String(solicitud?.estado).toLowerCase() === "rechazado") return "Rechazado";
    const est = String(solicitud?.estado || "").trim();
    if (!est || est.toLowerCase() === "pendiente" || est.toLowerCase() === "solicitado") return "Pendiente";
    return est;
  };

  const getTipoBadge = (tipo) => {
    switch (tipo) {
      case "Ingreso":
        return { variant: "info", icon: <FaCalendarAlt /> };
      case "Salida":
        return { variant: "primary", icon: <FaClock /> };
      default:
        return { variant: "secondary", icon: null };
    }
  };

  const formatearFecha = (timestamp) => {
    const fecha = parseFecha(timestamp);
    if (!fecha) return "-";
    try {
      return format(fecha, "dd/MM/yyyy HH:mm", { locale: es });
    } catch (error) {
      return "Fecha inválida";
    }
  };

  const formatearFechaCorta = (timestamp) => {
    const fecha = parseFecha(timestamp);
    if (!fecha) return "-";
    try {
      return format(fecha, "dd/MM/yyyy", { locale: es });
    } catch (error) {
      return "Fecha inválida";
    }
  };

  const formatearFechaCompleta = (timestamp) => {
    const fecha = parseFecha(timestamp);
    if (!fecha) return "-";
    try {
      return format(fecha, "EEEE, dd 'de' MMMM 'de' yyyy 'a las' HH:mm", {
        locale: es,
      });
    } catch (error) {
      return "Fecha inválida";
    }
  };

  const formatearFechaPeruana = (timestamp) => {
    const fecha = parseFecha(timestamp);
    if (!fecha) return "-";
    try {
      return format(fecha, "dd/MM/yyyy (EEEE) 'a las' HH:mm", { locale: es });
    } catch (error) {
      return "Fecha inválida";
    }
  };

  const limpiarFiltros = () => {
    const nuevosFiltros = {
      estado: "",
      tipo: "",
      fechaDesde: "",
      fechaHasta: "",
      empleado: "",
      grupo: "",
    };
    setFiltros(nuevosFiltros);
    cargarSolicitudes(false, nuevosFiltros);
  };

  const mostrarError = (mensaje) => {
    Swal.fire({
      icon: "error",
      title: "Error",
      text: mensaje,
    });
  };

  const calcularResumen = () => {
    return {
      total: solicitudes.length,
      pendientes: solicitudes.filter((s) => s.estado === "Pendiente").length,
      aprobadas: solicitudes.filter((s) => s.estado === "Aprobado").length,
      rechazadas: solicitudes.filter((s) => s.estado === "Rechazado").length,
      accionables: solicitudesAccionables.length,
      visibles: solicitudesVisibles.length,
    };
  };

  const resumen = calcularResumen();

  return (
    <Container fluid className="py-4">
      <Card
        className="shadow-lg border-0"
        style={{ borderRadius: "15px", overflow: "hidden", minHeight: "90vh" }}
      >
        {/* Header Premium con degradado verde oscuro */}
        <Card.Header
          className="text-white py-4 position-relative"
          style={{
            background: "linear-gradient(135deg, #0d4f3c 0%, #2c7a2c 100%)",
            borderBottom: "3px solid #f39c12",
            borderRadius: "15px 15px 0 0",
          }}
        >
          <div
            className="position-absolute end-0 top-50 translate-middle-y me-4"
            style={{ zIndex: 10 }}
          >
            <BotonManualHeader usuario={usuario} />
          </div>
          <div className="text-center">
            <h2 className="fw-bold mb-1">
              <FaCheckSquare className="me-3" />
              Aprobaciones de Regularización
            </h2>
            <p className="mb-0 opacity-75">
              Valida asistencias, permisos y justificaciones de marcación | RUC:{" "}
              {rucEmpresa || "–"}
            </p>
          </div>
        </Card.Header>

        <Card.Body>
          {/* Acciones Rápidas */}
          <Card
            className="border-0 mb-4"
            style={{
              background: "linear-gradient(135deg,#fffcea,#fff9db)",
              borderRadius: 14,
              boxShadow: "0 2px 12px rgba(109,40,217,.07)",
            }}
          >
            <Card.Body className="p-3 d-flex justify-content-center gap-3 flex-wrap">
              {/* Botón de recarga */}
              <Button
                variant="outline-dark"
                onClick={() => cargarSolicitudes(false)}
                disabled={loading}
                className="d-flex align-items-center gap-2 bg-white"
                style={{
                  borderRadius: "10px",
                  padding: "10px 20px",
                  fontWeight: "bold",
                }}
              >
                {loading ? <Spinner size="sm" /> : <FaClipboardList />}
                Recargar Solicitudes
              </Button>

              {/* Acciones masivas si hay seleccionados */}
              {seleccionados.size > 0 && (
                <>
                  <Button
                    variant="success"
                    onClick={aprobarSeleccionados}
                    disabled={procesando}
                    className="d-flex align-items-center gap-2"
                    style={{
                      borderRadius: "10px",
                      background: "linear-gradient(135deg, #28a745 0%, #20c997 100%)",
                      border: "none",
                      padding: "10px 20px",
                      fontWeight: "bold",
                      boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                    }}
                  >
                    <FaCheck size="16px" />
                    Aprobar Seleccionados ({seleccionados.size})
                  </Button>
                  <Button
                    variant="danger"
                    onClick={rechazarSeleccionados}
                    disabled={procesando}
                    className="d-flex align-items-center gap-2"
                    style={{
                      borderRadius: "10px",
                      background: "linear-gradient(135deg, #dc3545 0%, #c82333 100%)",
                      border: "none",
                      padding: "10px 20px",
                      fontWeight: "bold",
                      boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                    }}
                  >
                    <FaTimes size="16px" />
                    Rechazar Seleccionados ({seleccionados.size})
                  </Button>
                </>
              )}
            </Card.Body>
          </Card>
          {/* **OPTIMIZADO**: Info de filtros por defecto */}
          {primeraVez && (
            <Alert variant="info" className="mb-3">
              <strong>ℹ️ Carga Optimizada:</strong> Por defecto se muestran solo solicitudes <strong>Pendientes</strong> de los últimos <strong>30 días</strong> (máximo 100 registros).
              Usa los filtros para ver más registros.
            </Alert>
          )}

          {/* Resumen */}
	          <Alert variant="info" className="mb-4">
	            <Row>
              <Col md={3}>
                <strong>Mostrando:</strong> {resumen.total} {totalRegistros >= 100 && <small className="text-muted">(límite: 100)</small>}
              </Col>
              <Col md={3}>
                <strong>Pendientes:</strong> {resumen.pendientes}
              </Col>
              <Col md={3}>
                <strong>Aprobadas:</strong> {resumen.aprobadas}
              </Col>
	              <Col md={3}>
	                <strong>Rechazadas:</strong> {resumen.rechazadas}
	              </Col>
	            </Row>
              <Row className="mt-2">
                <Col md={6}>
                  <Badge bg="primary" className="fs-6">
                    Mi bandeja ({esSuperAdmin ? "SuperAdmin" : rolActual === "admin" ? "Admin" : rolActual === "rh" ? "RH" : "Usuario"}): {resumen.accionables}
                  </Badge>
                </Col>
                <Col md={6} className="text-md-end mt-2 mt-md-0">
                  <Badge bg="secondary" className="fs-6">
                    Mostrando: {resumen.visibles}
                  </Badge>
                </Col>
              </Row>
            {/* **NUEVO**: Mostrar count de seleccionados */}
            {seleccionados.size > 0 && (
              <Row className="mt-2">
                <Col>
                  <Badge bg="primary" className="fs-6">
                    {seleccionados.size} registros seleccionados
                  </Badge>
                </Col>
              </Row>
            )}
          </Alert>

	          {/* Filtros */}
	          <Card className="mb-4">
            <Card.Header className="bg-light">
              <h6 className="mb-0">
                <FaFilter className="me-2" />
                Filtros
              </h6>
            </Card.Header>
            <Card.Body>
              <Row>
                <Col md={2}>
                  <Form.Group>
                    <Form.Label>Estado</Form.Label>
                    <Form.Select
                      value={filtros.estado}
                      onChange={(e) =>
                        setFiltros({ ...filtros, estado: e.target.value })
                      }
                    >
                      <option value="">Todos</option>
                      <option value="Pendiente">Pendiente</option>
                      <option value="Aprobado">Aprobado</option>
                      <option value="Rechazado">Rechazado</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={2}>
                  <Form.Group>
                    <Form.Label>Tipo</Form.Label>
                    <Form.Select
                      value={filtros.tipo}
                      onChange={(e) =>
                        setFiltros({ ...filtros, tipo: e.target.value })
                      }
                    >
                      <option value="">Todos</option>
                      <option value="Ingreso">Ingreso</option>
                      <option value="Salida">Salida</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group>
                    <Form.Label className="small fw-bold">Empleado</Form.Label>
                    <Form.Select
                      size="sm"
                      value={filtros.empleado}
                      onChange={(e) =>
                        setFiltros({ ...filtros, empleado: e.target.value })
                      }
                    >
                      <option value="">Todos</option>
                      {empleados.map((emp) => (
                        <option key={emp.dni} value={emp.dni}>
                          {emp.apellidos ? `${emp.apellidos}, ${emp.nombres}` : emp.nombres}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={2}>
                  <Form.Group>
                    <Form.Label>Grupo</Form.Label>
                    <Form.Select
                      value={filtros.grupo}
                      onChange={(e) =>
                        setFiltros({ ...filtros, grupo: e.target.value })
                      }
                    >
                      <option value="">Todos</option>
                      {gruposDisponibles.map((grupo) => (
                        <option key={grupo} value={grupo}>
                          {grupo}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={2}>
                  <Form.Group>
                    <Form.Label>Fecha Desde</Form.Label>
                    <Form.Control
                      type="date"
                      value={filtros.fechaDesde}
                      onChange={(e) =>
                        setFiltros({ ...filtros, fechaDesde: e.target.value })
                      }
                    />
                  </Form.Group>
                </Col>
                <Col md={2}>
                  <Form.Group>
                    <Form.Label>Fecha Hasta</Form.Label>
                    <Form.Control
                      type="date"
                      value={filtros.fechaHasta}
                      onChange={(e) =>
                        setFiltros({ ...filtros, fechaHasta: e.target.value })
                      }
                    />
                  </Form.Group>
                </Col>
                <Col md={1} className="d-flex align-items-end">
                  <Button variant="outline-secondary" onClick={limpiarFiltros}>
                    Limpiar
                  </Button>
                </Col>
              </Row>
	              <Row className="mt-3">
	                <Col>
	                  <Button
                    variant="primary"
                    onClick={() => cargarSolicitudes(false)}
                    disabled={loading}
                  >
                    {loading ? <Spinner size="sm" className="me-2" /> : null}
	                    Buscar
	                  </Button>
                    <Form.Check
                      className="mt-3"
                      type="switch"
                      id="solo-mi-bandeja"
                      label="Solo mi bandeja (mostrar solo solicitudes que me corresponde aprobar/rechazar)"
                      checked={soloMiBandeja}
                      onChange={(e) => {
                        setSoloMiBandeja(e.target.checked);
                        setSeleccionados(new Set());
                        setSeleccionarTodos(false);
                      }}
                    />
	                </Col>
	              </Row>
	            </Card.Body>
	          </Card>

          {/* Tabla de solicitudes */}
          {loading ? (
            <div className="text-center py-4">
              <Spinner animation="border" />
              <p className="mt-2">Cargando solicitudes...</p>
            </div>
          ) : (
            <div className="table-responsive">
              <Table hover>
                <thead className="bg-light">
                  <tr>
                    {/* **NUEVO**: Checkbox para seleccionar todos */}
                    <th style={{ width: "50px" }}>
                      <Form.Check
                        type="checkbox"
                        checked={seleccionarTodos}
                        onChange={toggleSeleccionarTodos}
                        disabled={resumen.accionables === 0}
                        title="Seleccionar todas las que te corresponden"
                      />
                    </th>
                    <th>Empleado</th>
                    <th>Tipo</th>
                    <th>Fecha Solicitada</th>
                    <th>Fecha Creación</th>
                    <th>Estado</th>
                    <th>Justificación</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {solicitudesVisibles.length === 0 ? (
                    <tr>
                      <td colSpan="8" className="text-center py-4">
                        {filtros.estado === "Pendiente" ? (
                          <div>
                            <p className="mb-2 text-muted fw-bold">
                              🎉 ¡No hay solicitudes pendientes en este momento!
                            </p>
                            <Button
                              size="sm"
                              variant="outline-primary"
                              onClick={() => {
                                const nuevos = { ...filtros, estado: "" };
                                setFiltros(nuevos);
                                cargarSolicitudes(false, nuevos);
                              }}
                            >
                              Ver todas las solicitudes (Aprobadas / Rechazadas)
                            </Button>
                          </div>
                        ) : soloMiBandeja ? (
                          "No hay solicitudes en tu bandeja de aprobación"
                        ) : (
                          "No se encontraron solicitudes de regularización"
                        )}
                      </td>
                    </tr>
                  ) : (
	                    solicitudesVisibles.map((solicitud) => {
                      const tipoBadge = getTipoBadge(solicitud.tipo);
                      const flowStatus = String(getApprovalRequestFor(solicitud)?.status || solicitud.approvalStatus || "").trim();
                      const isPendiente = solicitud.estado === "Pendiente" || flowStatus.startsWith("pending_l");
                      const canAct = canUserActOnSolicitud(solicitud);
                      return (
                        <tr key={solicitud.id}>
                          {/* **NUEVO**: Checkbox individual */}
                          <td>
                            {isPendiente && canAct && (
                              <Form.Check
                                type="checkbox"
                                checked={seleccionados.has(solicitud.id)}
                                onChange={() => toggleSeleccion(solicitud.id)}
                              />
                            )}
                          </td>
                          <td>
                            <div>
                              <strong>
                                {solicitud.nombre} {solicitud.apellidos}
                              </strong>
                              <br />
                              <small className="text-muted">
                                DNI: {solicitud.dni}
                              </small>
                            </div>
                          </td>
                          <td>
                            <Badge bg={tipoBadge.variant}>
                              {tipoBadge.icon} {solicitud.tipo}
                            </Badge>
                          </td>
                          <td>{formatearFecha(solicitud.fechaSolicitada)}</td>
                          <td>{formatearFechaCorta(solicitud.createdAt)}</td>
                          <td>
                            <Badge bg={getBadgeVariant(flowStatus || solicitud.estado)}>
                              {getEstadoVisual(solicitud)}
                            </Badge>
                            {isPendiente && (
                              <div>
                                <small className={canAct ? "text-success" : "text-muted"}>
                                  {getUserActionLabel(solicitud)}
                                </small>
                              </div>
                            )}
                          </td>
                          <td>
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip>
                                  {solicitud.justificacion ||
                                    "Sin justificación"}
                                </Tooltip>
                              }
                            >
                              <span>
                                {solicitud.justificacion?.length > 30
                                  ? `${solicitud.justificacion.substring(
                                    0,
                                    30
                                  )}...`
                                  : solicitud.justificacion || "-"}
                              </span>
                            </OverlayTrigger>
                          </td>
                          <td>
                            <ButtonGroup size="sm">
                              <Button
                                variant="outline-info"
                                onClick={() => verDetalle(solicitud)}
                              >
                                <FaEye />
                              </Button>
                              {isPendiente && canAct && (
                                <>
                                  <Button
                                    variant="outline-success"
                                    onClick={() => aprobarSolicitud(solicitud)}
                                    disabled={procesando}
                                    title="Aprobar solicitud según tu nivel"
                                  >
                                    <FaCheck /> {rolActual === "admin" ? "Aprobar" : "Aprobar L1"}
                                  </Button>
                                  <Button
                                    variant="outline-danger"
                                    onClick={() => verDetalle(solicitud)}
                                    title="Rechazar solicitud según tu nivel"
                                  >
                                    <FaTimes /> {rolActual === "admin" ? "Rechazar" : "Rechazar L1"}
                                  </Button>
                                </>
                              )}
                            </ButtonGroup>
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </Table>
            </div>
          )}

          {/* BOTÓN CARGAR MÁS */}
          {!loading && hayMasResultados && (
            <div className="text-center mt-3">
              <Button
                variant="outline-primary"
                onClick={() => cargarSolicitudes(true)}
                disabled={cargandoMas}
                className="px-4 rounded-pill"
              >
                {cargandoMas ? <Spinner size="sm" className="me-2" /> : <FaClipboardList className="me-2" />}
                Cargar más registros
              </Button>
            </div>
          )}

        </Card.Body>
      </Card>

      {/* MODAL PROGRESO */}
      <Modal show={mostrarProgreso} centered backdrop="static" keyboard={false}>
        <Modal.Body className="text-center p-4">
          <h5 className="mb-3">Procesando solicitudes...</h5>
          <ProgressBar
            now={progresoActual}
            label={`${progresoActual}%`}
            striped animated
            variant="success"
            className="mb-2"
          />
          <p className="text-muted small mb-0">{mensajeProgreso}</p>
        </Modal.Body>
      </Modal>

      {/* Modal de detalle/aprobación/rechazo */}
      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            <FaEye className="me-2" />
            Detalle de Solicitud de Regularización
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {solicitudSeleccionada && (
            <Row>
              <Col md={12}>
                <Alert variant="info">
                  <Row>
                    <Col md={6}>
                      <strong>Empleado:</strong> {solicitudSeleccionada.nombre}{" "}
                      {solicitudSeleccionada.apellidos}
                    </Col>
                    <Col md={6}>
                      <strong>DNI:</strong> {solicitudSeleccionada.dni}
                    </Col>
                    <Col md={6}>
                      <strong>Email:</strong> {solicitudSeleccionada.email}
                    </Col>
                    <Col md={6}>
                      <strong>Cargo:</strong>{" "}
                      {solicitudSeleccionada.cargo || "No especificado"}
                    </Col>
                  </Row>
                </Alert>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Tipo de Registro</Form.Label>
                  <div>
                    <Badge
                      bg={getTipoBadge(solicitudSeleccionada.tipo).variant}
                      className="fs-6"
                    >
                      {getTipoBadge(solicitudSeleccionada.tipo).icon}{" "}
                      {solicitudSeleccionada.tipo}
                    </Badge>
                  </div>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Estado</Form.Label>
                  <div>
                    {(() => {
                      const modalFlowStatus = String(
                        getApprovalRequestFor(solicitudSeleccionada)?.status ||
                        solicitudSeleccionada?.approvalStatus ||
                        ""
                      ).trim();
                      return (
                    <Badge
                      bg={getBadgeVariant(modalFlowStatus || solicitudSeleccionada.estado)}
                      className="fs-6"
                    >
                      {getEstadoVisual(solicitudSeleccionada)}
                    </Badge>
                      );
                    })()}
                  </div>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Fecha y Hora Solicitada</Form.Label>
                  <Form.Control
                    type="text"
                    value={formatearFechaPeruana(
                      solicitudSeleccionada.fechaSolicitada
                    )}
                    disabled
                    className="fw-bold"
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Fecha de Creación</Form.Label>
                  <Form.Control
                    type="text"
                    value={formatearFechaPeruana(
                      solicitudSeleccionada.createdAt
                    )}
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col md={12}>
                <Form.Group className="mb-3">
                  <Form.Label>Justificación</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    value={solicitudSeleccionada.justificacion || ""}
                    disabled
                  />
                </Form.Group>
              </Col>

              {(solicitudSeleccionada.estado === "Pendiente" ||
                String(
                  getApprovalRequestFor(solicitudSeleccionada)?.status ||
                    solicitudSeleccionada?.approvalStatus ||
                    ""
                ).startsWith("pending_l")) && (
                <Col md={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Motivo de Rechazo (opcional)</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={motivoRechazo}
                      onChange={(e) => setMotivoRechazo(e.target.value)}
                      placeholder="Ingrese el motivo en caso de rechazar la solicitud..."
                    />
                  </Form.Group>
                </Col>
              )}

              {solicitudSeleccionada.estado === "Aprobado" && (
                <Col md={12}>
                  <Alert variant="success">
                    <strong>Aprobado por:</strong> {solicitudSeleccionada.aprobadoPor}<br />
                    <strong>Fecha de aprobación:</strong> {formatearFechaPeruana(solicitudSeleccionada.fechaAprobacion)}
                    {solicitudSeleccionada.observacionesAprobacion && (
                      <>
                        <br />
                        <strong>Observaciones:</strong> {solicitudSeleccionada.observacionesAprobacion}
                      </>
                    )}
                  </Alert>
                </Col>
              )}

              {solicitudSeleccionada.estado === "Rechazado" && (
                <Col md={12}>
                  <Alert variant="danger">
                    <strong>Rechazado por:</strong> {solicitudSeleccionada.rechazadoPor}<br />
                    <strong>Fecha de rechazo:</strong> {formatearFechaPeruana(solicitudSeleccionada.fechaRechazo)}<br />
                    <strong>Motivo:</strong> {solicitudSeleccionada.motivoRechazo}
                  </Alert>
                </Col>
              )}
            </Row>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cerrar
          </Button>
          {(solicitudSeleccionada?.estado === "Pendiente" ||
            String(
              getApprovalRequestFor(solicitudSeleccionada)?.status ||
                solicitudSeleccionada?.approvalStatus ||
                ""
            ).startsWith("pending_l")) && (
            <>
              <Button
                variant="danger"
                onClick={() => rechazarSolicitud(solicitudSeleccionada)}
                disabled={procesando}
              >
                {procesando ? (
                  <Spinner size="sm" className="me-2" />
                ) : (
                  <FaTimes className="me-2" />
                )}
                Rechazar
              </Button>
              <Button
                variant="success"
                onClick={() => aprobarSolicitud(solicitudSeleccionada)}
                disabled={procesando}
              >
                {procesando ? (
                  <Spinner size="sm" className="me-2" />
                ) : (
                  <FaCheck className="me-2" />
                )}
                Aprobar
              </Button>
            </>
          )}
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default AprobacionesAsistencia;
